import i18n from '@/api/i18n/i18n';

export const status = (val) => (val ? i18n.t('pages.running') : i18n.t('pages.closed'));
